module.exports = __webpack_public_path__ + "static/media/Home Page_website-04.94a340e1.png";